<template>
  <div class="content-block">
    <h2>Infosophy</h2>
    <p>
      <time>2017-04-25</time>
    </p>
    <p>
      All sciences originate from philosophy. I like to explain it this way, with a wink: Philosophy used to be the
      only science, and it was full of unanswered questions. Whenever a theoretical system could be established or a
      host of questions could be answered satisfactory, philosophers lost their interest in it, and so it became a
      science of itself.<br>
      Now, informatics or computer sciences started naive (which is good) and then figured, it was hard to grasp a
      programme, when it became more complicated. So the object-oriented programming was thought up, dividing parts of
      code into 'objects' for the sole purpose of making it easier to understand for developers, since (against common
      belief) developers are humans and we understand our world in objects.<br>
      Objects in programming languages are defined by classes, a concept very close to Plato's Ideology. It is a
      marvelous thing for a philosopher to see a model world where the Ideology is not only a theoretical system that
      tries to explain how we perceive the world, but that actually works as defined by it. Classes define properties
      and methods, which is a good system to work with objects in code. In most languages these are stable, in some
      (like JavaScript) the object can have new properties and methods, after they have been created from their class
      ('my dog can do a trick, no other dog can do') - which we can find in the real world as well and is easy to
      understand. From a philosopher's point of view, this is interesting and it is enriching to have a look at
      computer sciences.<br>
      But philosophers have been thinking about objects for about 2500 years, surely they have come up with ideas
      about them, that computer science could find useful as well? Let's have a look at Aristoteles
      <i title="or categories">Decem Genera</i>! Aristoteles looked at objects and found ten different
      <i title="kindly excuse my rough translation of those">attributes</i> inherent to them:
    </p>
    <ul>
      <li>Substance</li>
      <li>Quantity</li>
      <li>Quality</li>
      <li>Relation</li>
      <li>Location</li>
      <li>Time</li>
      <li>State</li>
      <li>Properties</li>
      <li>Acting</li>
      <li>Suffering</li>
    </ul>
    <p>
      Example:<br>
      Sokrates is of the Substance 'human', he has a Quantity of 70kg and another Quantity of 1.70m height. One of his
      Qualities is, that he knows how to speak. One of his Relations is, that he is the teacher of Plato, another that
      he lived about 2500 years before you. His Location would be Athens (best specified at a given point in time, I
      guess). His Time would be 469 to 399 before our time. His State could be 'sitting in a chair'. His Properties:
      wearing a toga and sandals. His Acting could be drinking a cup of poison hemlock. His Suffering: being poisoned.
    </p>
    <p>
      'Substance' could be translated as the class of the object, and while properties are pretty much
      self-explanatory, the 'acting' can be seen as the methods of a class. Can we find other categories, that are
      already in objects of some programming languages or is a programming language thinkable, that implements the
      other categories? Would we gain anything by implementing them?
    </p>
    <p>
      I'll stop here to ponder on this question. Let's not answer this too fast, lest the question will be no part of
      philosophy, again.
    </p>
  </div>
</template>

<script>
  export default {
    name: 'post-infosophy'
  }
</script>

<style scoped>
  time {
    font-style: italic;
  }

</style>



// WEBPACK FOOTER //
// infosophy.vue?312acfc7